var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 1.71094H0.999791C0.921219 1.71094 0.856934 1.77522 0.856934 1.85379V2.99665C0.856934 3.07522 0.921219 3.13951 0.999791 3.13951H14.9998C15.0784 3.13951 15.1426 3.07522 15.1426 2.99665V1.85379C15.1426 1.77522 15.0784 1.71094 14.9998 1.71094ZM14.9998 12.8538H0.999791C0.921219 12.8538 0.856934 12.9181 0.856934 12.9967V14.1395C0.856934 14.2181 0.921219 14.2824 0.999791 14.2824H14.9998C15.0784 14.2824 15.1426 14.2181 15.1426 14.1395V12.9967C15.1426 12.9181 15.0784 12.8538 14.9998 12.8538ZM14.9998 7.28237H0.999791C0.921219 7.28237 0.856934 7.34665 0.856934 7.42522V8.56808C0.856934 8.64665 0.921219 8.71094 0.999791 8.71094H14.9998C15.0784 8.71094 15.1426 8.64665 15.1426 8.56808V7.42522C15.1426 7.34665 15.0784 7.28237 14.9998 7.28237Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenu);
export default __webpack_public_path__ + "static/media/mobile-menu.e5cb08d30226152c54ad363d1f7f6225.svg";
export { ForwardRef as ReactComponent };